import { createContext, useEffect, useTransition } from "react";
import { useState } from "react";
import { defaultFormData } from "../data/defaultFormData";
import { useAppData } from "../hooks/useAppData";

const DataContext = createContext();

const DataProvider = ({ children }) => {
  const { setFormStarted } = useAppData();
  const [, startTransistion] = useTransition();
  const [formData, setFormData] = useState(defaultFormData);

  // Set values into data state when typing in forms
  const setValues = (e) => {
    startTransistion(() => {
      if (e !== "reset") {
        setFormData({
          ...formData,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
          form_started: true,
        });
        setFormStarted(true);
      } else {
        setFormData(defaultFormData);
      }
    });
  };

  // Get old form data from localstorage and set into state if found
  useEffect(() => {
    const getOldData = async () => {
      try {
        const res = await localStorage.getItem("formdata");
        if (res) {
          setFormData(JSON.parse(res));
          if (JSON.parse(res).form_started) {
            setFormStarted(true);
          }
        }
      } catch (e) {
        console.log("Cant get data from localStorage");
      }
    };
    getOldData();
    // eslint-disable-next-line
  }, []);

  // Save formdata into localstorage when formdata changes
  useEffect(() => {
    const setLocal = async () => {
      try {
        const res = await localStorage.getItem("formdata");

        if (res) {
          if (res !== JSON.stringify(formData)) {
            await localStorage.setItem("formdata", JSON.stringify(formData));
          }
        } else {
          await localStorage.setItem("formdata", JSON.stringify(formData));
        }
      } catch (e) {
        console.log("Cant save data to localStorage");
      }
    };
    // eslint-disable-next-line
    setLocal();
  }, [formData]);

  const clearFormData = () => {
    setFormData(defaultFormData);
    setFormStarted(false);
  };

  return (
    <DataContext.Provider value={{ formData, setValues, clearFormData }}>
      {children}
    </DataContext.Provider>
  );
};

export { DataProvider, DataContext };
